import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { SignatureService } from "../../services/signature.service";
import { findSignatureGroupAct, loadSignatureGroupByIdAct, saveSignatureGroupAct, saveSuccessSignatureGroupAct, setViolationsSignatureGroupAct, showMsgErrorAct, updateSignatureGroupAct, updateSuccessSignatureGroupAct } from "./signatures.actions";
import { EMPTY, catchError, exhaustMap, map, of, tap } from "rxjs";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class SignatureGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private signatureService = inject(SignatureService);
    private alerta = inject(AlertaService);

    findSignatureGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findSignatureGroupAct),
            exhaustMap(action => this.signatureService.findSignatureGroupById(action.id)
        .pipe(
            map(signatureGroup => loadSignatureGroupByIdAct({ signatureGroup })),
            catchError(error => of(error))
        ))
        )
    );


    saveSignatureGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveSignatureGroupAct),
            exhaustMap(action => this.signatureService.createSignatureGroup(action.signatureGroupNew)
                .pipe(
                    map(signatureGroupNew => saveSuccessSignatureGroupAct({ signatureGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsSignatureGroupAct({ signatureGroupForm: action.signatureGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            /*Swal.fire({
                title: "Error",
                text: "Se ha precentado un error interno: " + action.error.message,
                icon: "error",
            });*/
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });

    saveSuccessSignatureGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessSignatureGroupAct),
        tap(() => {
            this.router.navigate(['/signatures']);
            this.alerta.correct("Oferta creado con exito!");
        })
    ), { dispatch: false });

    updateSignatureGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateSignatureGroupAct),
            exhaustMap(action => this.signatureService.updateSignatureGroup(action.signatureGroupUpdated)
                .pipe(
                    map(signatureGroupUpdated => updateSuccessSignatureGroupAct({ signatureGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsSignatureGroupAct({ signatureGroupForm: action.signatureGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessSignatureGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessSignatureGroupAct),
        tap(() => {
            this.router.navigate(['/signatures']);
            this.alerta.correct("Oferta editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            var nameV: string = item.path.slice(item.path.indexOf('.') + 1);
            nameV = nameV.replace('[', '');
            nameV = nameV.replace(']', '');
            obj[nameV] = item.message;
            return obj;
        }, {});
    };
}